/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type LandingPageTargetResponse = {
    id?: number;
    bootCampCategory?: LandingPageTargetResponse.bootCampCategory;
    sequence?: number;
    contents?: string;
    imgUrl?: string;
    alt?: string;
};

export namespace LandingPageTargetResponse {

    export enum bootCampCategory {
        ALL = 'ALL',
        SEBFE = 'SEBFE',
        SEBBE = 'SEBBE',
        UUB = 'UUB',
        GMB = 'GMB',
        DOB = 'DOB',
        PMB = 'PMB',
        BEB = 'BEB',
        AIB = 'AIB',
    }


}

